
import { useState } from "react";

import { initialState } from "../App";
import HomePage from "./home";
import SignInModal from "./sign-in";
import { NotFound } from "../errors";
import { Route, Routes, useLocation } from "react-router-dom";


export default function Landing(){
    const [scrolled, setScroll] = useState(false);
    const location = useLocation();
    const [showSignIn, setSignIn] = useState(location.pathname.slice(1));

    
    function handleScroll(e) {
        const status = e.target.scrollTop > 10
        status !== scrolled && setScroll(status);
    }

    return (
        <div className="App landing" onScroll={handleScroll}>
            {
                ! ( ["/register", "/login"].includes(location.pathname) ) &&
                <Routes>
                    <Route path='' element={
                        <HomePage scroll={scrolled} setSignIn={setSignIn} />
                        }
                    ></Route>
                    <Route path='*' element={<NotFound />}></Route>
                </Routes>
            }
            { 
                showSignIn && 
                ["register", "login"].includes(showSignIn) &&

                <SignInModal show={showSignIn} set={setSignIn} />
            }
        </div>
    )
}